import React, { useEffect, useState } from 'react';
import '../../Assets/CSS/popularCate.css';
import axios from 'axios';
import { getCookie } from '../../components/auth/login/GetCookie';

const PopularCategories = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCategories = async () => {
            setLoading(true)
            // const token = localStorage.getItem('token');
            const token = getCookie("token");
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/category`, {
                    headers: {
                        'Accept': '*/*',
                        'Authorization': `Bearer ${token}`,
                    },
                });
                setCategories(response.data);
                // setLoading(false);
            } catch (err) {
                console.error('Error fetching categories:', err);
                setError('Failed to load categories. Please try again later.');
                // setLoading(false);
            }finally{
                setLoading(false);
            }
        };

        fetchCategories();
    }, []);

    // if (loading) {
    //     return <div>Loading categories...</div>;
    // }

    if (error) {
        return <div className="text-danger">{error}</div>;
    }

    return (
        <div className="popular-categories-container mb-5 popularCate">
            <h1 className="heading px-5 pb-1 " style={{ color: '#303030', marginBottom:'30px' }}>Popular Categories</h1>
            <div className="grid-container px-lg-5 px-3" style={{gridAutoRows:'250px'}}>
            {loading
                    ? Array.from({ length: 10 }).map((_, index) => (
                        <div key={index} className={`grid-item div${index + 1}`}>
                          <div
                            style={{
                            width: '100%',
                            height: '100%',
                            backgroundColor: '#e0e0e0',
                            animation: 'pulse 1.5s infinite',
                            borderRadius: '10px'
                        }}
                    >
                        {/* Text Skeleton */}
            <div
              className="skeleton-text"
              style={{
                width: '60%',
                height: '20px',
                backgroundColor: '#ccc',
                borderRadius: '5px',
                position: 'absolute',
                bottom: '10px',
                right: '10px',
                animation: 'pulse 1.5s infinite',
              }}
            />
                    </div>
                        </div>
                    ))
                    :
                categories.slice(0, 10).map((cat, index) => (
                    <div key={cat.categoryId} className={`grid-item div${index + 1}`}>
                        <div className="image-wrapper">
                            <img
                                src={cat.categoryImageUrl || 'https://via.placeholder.com/200'}
                                alt={cat.categoryName}
                            />
                        </div>
                        <span className="image-name-overlay">{cat.categoryName}</span>
                        <div className="overlay"></div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PopularCategories;



